import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutoLogoutService } from '../shared/service/auto-logout.service';
import { AdminLatestTemplateService } from '../shared/service/admin-latest-template.service';
import { LatestTemplate } from '../shared/model/LatestTemplate';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { CommonService } from '../shared/service/common.service';
import { FileUploadService } from '../shared/service/file-upload.service';
const LOCAL_USER_KEY = "UserName";
const STORE_KEY = 'lastAction';

@Component({
  selector: 'app-admin-latest-template',
  templateUrl: './admin-latest-template.component.html',
  styleUrls: ['./admin-latest-template.component.css']
})
export class AdminLatestTemplateComponent implements OnInit {
  LocalToken: string = '';
  latestTemplateObj: LatestTemplate = {
    Id: null,
    ImageName: null,
    ImageUrl: null
  };
  latestTemplateArr = [];
  @BlockUI() blockUI: NgBlockUI;
  fileListObj: FileList;
  constructor(private router: Router, private autoLogoutService: AutoLogoutService, private adminLatestTemplateService: AdminLatestTemplateService, private commonService: CommonService, private fileUploadService: FileUploadService) {
    localStorage.setItem(STORE_KEY, Date.now().toString());
    this.autoLogoutService.check();
    this.autoLogoutService.initListener();
    this.autoLogoutService.initInterval();
  }

  ngOnInit() {
    this.LocalToken = localStorage.getItem(LOCAL_USER_KEY);
    if (this.LocalToken != null) {
      this.getLatestTEmplate();
    }
    else {
      this.router.navigate(["admin/logIn"]);
    }

  }

  getLatestTEmplate() {
    this.adminLatestTemplateService
      .getLatestTemplate()
      .then((result) => {
        this.latestTemplateArr = result;
        if (this.latestTemplateArr.length > 0) {
          this.latestTemplateObj = this.latestTemplateArr[0];
        }
      })
      .catch((err) => console.log(err));
  }

  public docChoose(fileInput: any, category: string) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.latestTemplateObj.ImageName = "";
      if (category == "LatestTemplateImage") {
        this.latestTemplateObj.ImageName = encodeURI(fileInput.target.files[0].name);
      }
    }
  }

  removeFile(event) {
    var itemtoRemove = event.target.outerText;
    if (itemtoRemove) {
      if (confirm("Image will deleted permenently. Are you sure?")) {
        if (this.latestTemplateObj.Id) {
          this.latestTemplateObj.ImageName = null;
          let parentFolder = "LatestTemplate"
          this.commonService
            .FileDelete(this.latestTemplateObj.Id, itemtoRemove, parentFolder).then(() => console.log("file delete")).catch((err) => this.errorHandler(err));
        }
        else {
          this.latestTemplateObj.ImageName = null;
        }

      }
    }
  }

  fileChange(event, category) {
    this.docChoose(event, category);
    this.fileListObj = event.target.files;
  }

  SaveLatestTemplate() {
    this.blockUI.start("Please Wait .......");
    if (this.fileListObj) {
      if (this.latestTemplateObj.Id) {
        this.adminLatestTemplateService
          .editLatestTemplate(this.latestTemplateObj)
          .then((result) => {
            let folderName = "LatestTemplate\\" + result;
            this.fileUploadService.ImageUpload(this.fileListObj, folderName).then(() => {
              console.log("Add");              
              this.blockUI.stop();
            })
              .catch((err) => this.errorHandler(err));
          })
          .catch((err) => this.errorHandler(err));
      }
      else {
        this.adminLatestTemplateService
          .addLatestTemplate(this.latestTemplateObj)
          .then((result) => {
            let folderName = "LatestTemplate\\" + result;
            this.fileUploadService.ImageUpload(this.fileListObj, folderName).then(() => {
              console.log("Add");              
              this.blockUI.stop();
            })
              .catch((err) => this.errorHandler(err));
          })
          .catch((err) => this.errorHandler(err));
      }
    }
    else {
      if (this.latestTemplateObj.Id) {
        this.adminLatestTemplateService
          .editLatestTemplate(this.latestTemplateObj)
          .then((result) => {
            this.blockUI.stop();
          })
          .catch((err) => this.errorHandler(err));
      }
      else {
        this.adminLatestTemplateService
          .addLatestTemplate(this.latestTemplateObj)
          .then((result) => {
            this.blockUI.stop();
          })
          .catch((err) => this.errorHandler(err));
      }
    }

  }


  clearControl() {
    this.latestTemplateObj = {
      Id: null,
      ImageName: null,
      ImageUrl: null
    };
  }

  errorHandler(err: any) {
    console.log(err);
    this.blockUI.stop();
  }

}
